/**
 * Delays the execution for a specified amount of time.
 * @param ms - The number of milliseconds to delay the execution. Default is 1000.
 * @returns A promise that resolves after the specified delay.
 */
export const sleep = (ms: number = 1000) =>
  new Promise((resolve) => {
    setTimeout(resolve, ms)
  })
